import React from "react";
import VideoPreviewDetails from "./VideoPreviewDetails";

export default function VideoPreviewModal({ video, onClose, onEdit }) {
  if (!video) return null;
  return <VideoPreviewDetails video={video} onClose={onClose} onEdit={onEdit} />;
}